import { Action } from 'redux';
import { DateFilterField, GetSalesOrderDemandsOutput, SalesOrderDemandSortDirection } from '../types';

export const SALES_ORDER_DEMAND_LIST_GET = 'salesOrderDemandList/get';
export const SALES_ORDER_DEMAND_LIST_LOADED = 'salesOrderDemandList/loaded';
export const SALES_ORDER_DEMAND_LIST_ERROR = 'salesOrderDemandList/error';
export const SALES_ORDER_DEMAND_LIST_PAGE_CHANGE = 'salesOrderDemandList/pageChange';
export const SALES_ORDER_DEMAND_LIST_LOAD_MORE = 'salesOrderDemandList/loadMore';
export const SALES_ORDER_DEMAND_LIST_SORT_CHANGE = 'salesOrderDemandList/sortChange';
export const SALES_ORDER_DEMAND_LIST_FILTER_CHANGE = 'salesOrderDemandList/filterChange';

export interface SalesOrderDemandListGetAction extends Action {
    type: typeof SALES_ORDER_DEMAND_LIST_GET;
}

export interface SalesOrderDemandListLoadedAction extends Action {
    type: typeof SALES_ORDER_DEMAND_LIST_LOADED;
    payload: GetSalesOrderDemandsOutput;
}

export interface SalesOrderDemandListErrorAction extends Action {
    type: typeof SALES_ORDER_DEMAND_LIST_ERROR;
    payload: { error: any };
}

export interface SalesOrderDemandListPageChangeAction extends Action {
    type: typeof SALES_ORDER_DEMAND_LIST_PAGE_CHANGE;
    payload: { currentPage: number; currentRecordNumber: number };
}

export interface SalesOrderDemandListLoadMoreAction extends Action {
    type: typeof SALES_ORDER_DEMAND_LIST_LOAD_MORE;
    payload: { currentPage: number; currentRecordNumber: number };
}

export interface SalesOrderDemandListSortChangeAction extends Action {
    type: typeof SALES_ORDER_DEMAND_LIST_SORT_CHANGE;
    payload: { sortColumn: string; sortDirection: SalesOrderDemandSortDirection };
}

export interface SalesOrderDemandListFilterChangeAction extends Action {
    type: typeof SALES_ORDER_DEMAND_LIST_FILTER_CHANGE;
    payload: {
        poIds?: string[];
        unitsStatusFilter?: string[];
        asinFilter?: string[];
        resellerSkuFilter?: string[];
        familyFilter?: string[];
        dateRange?: string[];
        dateFilterField?: DateFilterField;
        shipToLocationFilter?: string[];
    };
}

export type SalesOrderDemandListActions =
    | SalesOrderDemandListGetAction
    | SalesOrderDemandListLoadedAction
    | SalesOrderDemandListErrorAction
    | SalesOrderDemandListPageChangeAction
    | SalesOrderDemandListLoadMoreAction
    | SalesOrderDemandListSortChangeAction
    | SalesOrderDemandListFilterChangeAction;
